const validateEmail = (email) => {
  const regex =
    /^[a-z0-9]((\.|_|-)?[a-z0-9]){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z{2,4}|[0-9]{1,3})(\]?|^\.)$/g;
  return regex.test(email);
};

export default validateEmail;
